import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { toggleEditorTheme } from "../../../reducers/settings/actions";
import { navigate } from "../../../services";
import { isPointInRect } from "../../../helpers";
import { EVT_MOUSEDOWN } from "../../../lib";

import { Container, MenuItem } from "./List";
import Icon from "./Icon";

const mapDispatch = { toggleEditorTheme };

type DispatchProps = typeof mapDispatch;
type OwnProps = {
    doc_id: number;
    enableDarkTheme: boolean;
    canAdminister: boolean;
    iconElm: React.RefObject<Icon>;

    hideMenu: () => void;
};
type Props = DispatchProps & OwnProps;

class SettingsList extends React.Component<Props> {
    private elmContainer: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);
        this.elmContainer = React.createRef<HTMLDivElement>();
    }

    componentDidMount() {
        window.addEventListener(EVT_MOUSEDOWN, this.onMouseDown);
    }

    componentWillUnmount() {
        window.removeEventListener(EVT_MOUSEDOWN, this.onMouseDown);
    }

    onMouseDown = (evt: MouseEvent) => {
        if (!this.elmContainer || !this.elmContainer.current) {
            return;
        }

        const elm = this.elmContainer.current;
        if (
            !isPointInRect(
                { x: evt.clientX, y: evt.clientY },
                elm.getBoundingClientRect()
            )
        ) {
            this.close();
        }
    };

    onClick = (id: string) => {
        const { doc_id } = this.props;
        if (id === "pages") {
            navigate.to(`/app/pages/${doc_id}/`);
        } else if (id === "users") {
            navigate.to(`/app/users/${doc_id}/`);
        } else if (id === "toggleTheme") {
            this.props.toggleEditorTheme(null);
        } else if (id === "export") {
            navigate.to(`/app/export/${doc_id}/`);
        } else if (id === "translate") {
            navigate.to(`/app/translate/${doc_id}/`);
        }

        this.close();
    };

    close = () => this.props.hideMenu();

    render() {
        const { enableDarkTheme, canAdminister } = this.props;
        const list = [];

        if (canAdminister) {
            list.push({ id: "pages", messageId: "editorMenu.pages" });
            list.push({ id: "users", messageId: "editorMenu.users" });
        }

        // list.push({ id: 'translate', messageId: 'editorMenu.translate' })
        list.push({ id: "toggleTheme", messageId: "editorMenu.toggleTheme" });
        // list.push({ id: 'export', messageId: 'editorMenu.export' })

        return (
            <Container
                enableDarkTheme={enableDarkTheme}
                ref={this.elmContainer}
            >
                {list.map(({ id, messageId }) => (
                    <MenuItem
                        key={messageId}
                        justifyContent="center"
                        enableDarkTheme={enableDarkTheme}
                        onClick={() => this.onClick(id)}
                    >
                        <FormattedMessage id={messageId} />
                    </MenuItem>
                ))}
            </Container>
        );
    }
}

export default connect(null, mapDispatch)(SettingsList);
